import { createSelector } from 'reselect'
import { getCampaignSelector } from 'redux/selectors/campaign'

export default createSelector(
  [getCampaignSelector],
  campaign => campaign.has_currency_balance
)
